import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wordpress-simple': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c136.7 0 248 111.2 248 248 0 136.7-111.3 248-248 248s-248-111.3-248-248c0-136.8 111.3-248 248-248zM33 256c0 88.2 51.3 164.5 125.7 200.7l-106.4-291.4c-12.4 27.7-19.3 58.4-19.3 90.7zM256 479c26 0 50.9-4.5 74-12.6-0.6-1-1.1-2-1.6-3.1l-68.5-187.8-66.9 194.4c20 5.9 41.1 9.1 63 9.1zM286.7 151.5l80.7 239.6 22.2-74.3c9.7-30.9 17-53 17-72.1 0-27.6-9.9-46.7-18.4-61.5-11.3-18.4-21.9-33.9-21.9-52.3 0-20.5 15.5-39.6 37.4-39.6 1 0 1.9 0.1 2.9 0.2-39.7-36.3-92.6-58.5-150.6-58.5-77.9 0-146.4 40-186.3 100.5 5.3 0.2 10.2 0.3 14.4 0.3 23.3 0 59.4-2.8 59.4-2.8 12-0.7 13.4 17 1.4 18.4 0 0-12.1 1.4-25.5 2.1l81.2 241.5 48.8-146.3-34.7-95.2c-12-0.7-23.4-2.1-23.4-2.1-12-0.7-10.6-19.1 1.4-18.4 0 0 36.8 2.8 58.7 2.8 23.3 0 59.4-2.8 59.4-2.8 12-0.7 13.4 17 1.4 18.4 0 0-12.1 1.4-25.5 2.1zM368.1 448.7c66.3-38.6 110.9-110.4 110.9-192.7 0-38.8-9.9-75.2-27.3-107 1 7.1 1.5 14.7 1.5 22.9 0 22.7-4.3 48.1-17 79.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wordpress-simple.js
// module id = 1099
// module chunks = 0